import {Injectable} from '@angular/core';
import {AbstractItem, ItemCatalog} from "@app/shared/classes/item";
import {ContractSummary} from "@app/shared/classes/contract-summary";
import {ChartOfAccount, TreeView} from "@app/shared";
import {TreeNode} from "primeng/api";

@Injectable()
export class LocalCacheService {

  salesTaxItem: AbstractItem;                         // user's org sales tax item - cached for Procure-to-Pay and Order-to-Cash
  contractSummary: ContractSummary[];
  itemCatalogs: ItemCatalog[];
  treeViews: Array<TreeView[]>;
  ledgerAccountTreeNodes: TreeNode<ChartOfAccount>[];

  constructor() { // only initialize treeViews
    this.treeViews = [];
  }

  reset() {
    this.salesTaxItem = null;
    this.contractSummary = null;
    this.itemCatalogs = null;
    this.treeViews = [];
  }
}
